module.exports = __webpack_public_path__ + "media/durango/torres-b149314c.jpg";